import type { IWatermarkElement } from '@/types/watermarks.types';
import styles from '../watermark.module.css';
import classNames from 'classnames';
import type { CSSProperties } from 'react';

type TiledElementListRef = React.RefObject<Map<IWatermarkElement['uuid'], string>>;
const TiledEl = ({ el, tiledImages }: { el: IWatermarkElement; tiledImages: TiledElementListRef }) => {
  return (
    <img
      draggable={false}
      src={tiledImages.current.get(el.uuid)} // this is in a weak map, and depends on the render count increasing to update
      className={classNames(styles.tiledImage, { [styles.pulse]: el.settings.duration === 'pulse' })}
      style={
        {
          opacity: 'var(--wm-opacity)',
          '--wm-opacity': el.settings.opacity ?? 1,
          '--wm-rotate': `${el.settings.dimensions.rotation ?? 0}deg`,
        } as CSSProperties
      }
    />
  );
};

export default TiledEl;
